export const GET_ALL_COMMUNITIES = "GET_ALL_COMMUNITIES";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_COMMUNITIES = "START_LOADING_COMMUNITIES";
export const STOP_LOADING_COMMUNITIES = "STOP_LOADING_COMMUNITIES";
export const ERROR_LOADING_COMMUNITIES = "ERROR_LOADING_COMMUNITIES";